const ErrorPage = () => {
  return (
    <>
      <p>
        Niestety Twój wniosek nie został złożony. Spróbuj złożyć go ponownie.
      </p>
      <div className="row px-3 mb-3 mt-4">
        <div className="col-sm-12 code">
          <div className="mr-12 float-right">
            <button
              className="againBtn"
              onClick={() => {
                window.location.href = "/";
              }}
            >
              Ponowne złożenie wniosku
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export { ErrorPage };
